module.exports = __webpack_public_path__ + "img/section0.31ac0ebc.jpg";